export enum AppRoutePaths {
  ADMIN = 'admin',
  AKQUISE = 'akquise',
  AKQUISEOBJEKTE = 'akquiseobjekte',
  ARTIKEL = 'artikel',
  AUFGABEN = 'aufgaben',
  MANDANTEN = 'mandanten',
  AUSWERTUNGEN = 'auswertungen',
  AUTH = 'auth',
  BESPRECHUNGEN = 'besprechungen',
  BESTELLUNGEN = 'bestellungen',
  ZU_BESTELLEN = 'zu-bestellen',
  BETRIEBSMITTEL = 'betriebsmittel',
  CHATS = 'chats',
  DASHBOARD = 'dashboard',
  DOKUMENTE = 'dokumente',
  DOKUMENTENMANAGER = 'dokumentenmanager',
  EINKAUF = 'einkauf',
  ELEKTRO_DRITTKONTROLLE = 'elektro-drittkontrolle',
  FEHLER = 'fehler',
  FINANZEN = 'finanzen',
  GERUESTBAU = 'geruestbau',
  KONTAKTE = 'kontakte',
  KUNDENSUPPORT = 'kundensupport',
  LISTE = 'liste',
  MITARBEITER = 'mitarbeiter',
  MITTEILUNGEN = 'mitteilungen',
  FERIENKALENDER = 'ferienkalender',
  MONTAGEPLAN = 'montageplan',
  WOCHENUEBERSICHT = 'wochenuebersicht',
  PROFILE = 'profile',
  PROJEKTE = 'projekte',
  SCREENS = 'screens',
  TODOS = 'todos',
  VERANSTALTUNGEN = 'veranstaltungen',
  ZIELGRUPPEN = 'zielgruppen',
}

export enum AppRouteViewTypes {
  LISTE = 'liste',
  DETAILS = 'details',
  UEBERSICHT = 'uebersicht',
}

export enum AppRouteNavItems {
  ADMIN_PAGE_ROUTES = 'adminPageRoutes',
  ADMIN_ENERGIEVERSORGER_DETAILS_PAGE_ROUTE = 'adminEnergieversorgerDetailsPageRoute',
  ADMIN_PRODUKTGRUPPEN_DETAILS_PAGE_ROUTE = 'adminProduktgruppenDetailsPageRoute',
  AKQUISE_PAGE_ROUTES = 'akquisePageRoutes',
  AKQUISEOBJEKTE_DETAILS_PAGE_ROUTE = 'akquiseobjekteDetailsPageRoute',
  ARTIKEL_PAGE_ROUTES = 'artikelPageRoutes',
  ARTIKEL_DETAILS_PAGE_ROUTES = 'artikelDetailsPageRoutes',
  AUFGABEN_PAGE_ROUTE = 'aufgabenPageRoute',
  BETRIEBSMITTEL_PAGE_ROUTE = 'betriebsmittelPageRoute',
  EINKAUF_PAGE_ROUTES = 'einkaufPageRoutes',
  EINKAUF_BESTELLUNG_DETAILS_PAGE_ROUTE = 'einkaufBestellungDetailsPageRoute',
  FINANZEN_PAGE_ROUTE = 'finanzenPageRoute',
  KONTAKTE_PAGE_ROUTE = 'kontaktePageRoute',
  KONTAKTE_DETAILS_PAGE_ROUTE = 'kontakteDetailsPageRoute',
  KUNDENSUPPORT_PAGE_ROUTE = 'kundensupportPageRoute',
  MANDANTEN_PAGE_ROUTE = 'mandantenPageRoute',
  MITARBEITER_PAGE_ROUTE = 'mitarbeiterPageRoute',
  MITARBEITER_DETAILS_PAGE_ROUTE = 'mitarbeiterDetailsPageRoute',
  MITTEILUNGEN_PAGE_ROUTE = 'mitteilungenPageRoute',
  MITTEILUNGEN_DETAILS_PAGE_ROUTE = 'mitteilungenDetailsPageRoute',
  MONTAGENPLAN_PAGE_ROUTE = 'montageplanPageRoute',
  PROFIL_PAGE_ROUTE = 'profilPageRoute',
  PROJEKTE_PAGE_ROUTE = 'projektePageRoute',
  PROJEKTE_DETAILS_PAGE_ROUTE = 'projekteDetailsPageRoute',
  SCREENS_PAGE_ROUTE = 'screensPageRoute',
  BESPRECHUNGEN_PAGE_ROUTE = 'besprechungenPageRoute',
  BESPRECHUNGEN_VORLAGEN_DETAILS_PAGE_ROUTE = 'besprechungenVorlagenDetailsPageRoute',
  TODOS_PAGE_ROUTE = 'todosPageRoute',
  VERANSTALTUNGEN_PAGE_ROUTE = 'veranstaltungenPageRoute',
  VERANSTALTUNGEN_DETAILS_PAGE_ROUTE = 'veranstaltungenDetailsPageRoute',
  ZIELGRUPPEN_DETAILS_PAGE_ROUTES = 'zielgruppenDetailsPageRoutes',
}
